(function() {
  "use strict";

  angular
    .module('modules.googleMaps', [
      'uiGmapgoogle-maps'
    ])
  ;

})();